// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-tournament-matches__container {
    padding-top: 70px;
}

.hub-tournament-matches__title {
    position: absolute;
    top: 72px;
    left: calc(calc(calc(100% /12) * 3) - var(--space-and-half) );
    padding: 24px 58px;
    width: 100%;
    background: var(--white-color);
    text-align: left;
    z-index: 1;
    border-left: 1px solid var(--new-background-color);
}

.hub-tournament-matches__title.baloa-headline-3 {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches__empty{
    width: 364px;
    text-align: center;
    margin: 50px auto;
}

.hub-tournament-matches__empty .baloa-subtitle-2 {
    font-weight: var(--font-regular);
    color: var(--primary-dark-color);
    margin-top: 30px;
}

.hub-tournament-matches__accordion {
    margin-bottom: 16px;
    border-radius: 4px;
}

.hub-tournament-matches__tournament-matches  {
    border-radius: 4px;
}

.hub-tournament-matches__tournament-matches.MuiPaper-elevation1 {
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
}

.hub-tournament-matches__tournament-matches .MuiAccordionDetails-root {
    padding: 10px;
}

.hub-tournament-matches__tournament-matches .MuiAccordionSummary-root {
    min-height: 42px;
}

.hub-tournament-matches__tournament-matches .MuiAccordionSummary-root.Mui-expanded {
    min-height: 42px;
}

.hub-tournament-matches__matches.MuiButtonBase-root{
    background-color: var(--new-light-gray-background-color);    
    border-bottom: 1px solid var(--new-gray-background-color);
    border-radius: 4px 4px 0 0;
}

.hub-tournament-matches__matches .MuiAccordionSummary-content,
.hub-tournament-matches__matches .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
}

.hub-tournament-matches__matches .MuiIconButton-root {
    padding: 0 12px;
}

.hub-tournament-matches__matches__container{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    width: 100%;
}

.hub-tournament-matches__matches__match{
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    cursor: pointer;
}

.hub-tournament-matches__matches__match-info{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.hub-tournament-matches__matches__match-date {
    background-color: var(--new-background-color);
    border-radius: 2px;
    width: fit-content;
    padding: 2px;
}

.hub-tournament-matches__matches__match-date.baloa-username {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches__matches__match-state {
    padding: 2px;
    border-radius: 2px;
    width: fit-content;
    background: var(--basic-gray-color);
}

.hub-tournament-matches__matches__match-state.baloa-username {
    color: var(--white-color);
}

.hub-tournament-matches__matches__match-team {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.hub-tournament-matches__matches__match-team .icon-ball {
    color: var(--white-color );
    font-size: 24px;
    border-radius: 50%;
    padding: 3px;
    margin-right: 8px;
}

.hub-tournament-matches__matches__match-team img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 8px;
}

.hub-tournament-matches__matches__match-team.baloa-names {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches__tournament_info {
    display: flex;
    align-items: center;
    /* background: var(--new-background-color);
    padding: 2px 4px;
    border-radius: 2px; */
}

.hub-tournament-matches__tournament_info img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
}

.hub-tournament-matches__tournament_info .icon-ball {
    color: var(--white-color );
    font-size: 24px;
    border-radius: 50%;
    padding: 3px;
    margin-right: 10px;
}

.hub-tournament-matches__tournament_info .baloa-names {
    color: var(--primary-very-dark-color);
}

.hub-tournament-matches__matches__match-team-score {
    margin-left: auto;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .hub-tournament-matches__container {
        padding-top: 0;
    }

    .hub-tournament-matches__accordion {
        margin-bottom: 12px;
    }

    .hub-tournament-matches__tournament-matches .MuiAccordionSummary-root.Mui-expanded {
        min-height: 36px;
    }

    .hub-tournament-matches__tournament_info img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    .hub-tournament-matches__matches__container {
        display: block;
    }

    .hub-tournament-matches__tournament-matches .MuiAccordionDetails-root {
        padding: 0;
    }

    .hub-tournament-matches__matches__match {
        padding: 8px;
        border-radius: 0;
        border: unset;
        border-bottom: 1px solid var(--new-gray-background-color);
    }

    .hub-tournament-matches__matches__match-date {
        margin: auto;
    }

    .hub-tournament-matches__matches__match-state {
        margin: auto;
    }

    .hub-tournament-matches__matches__match-teams-info {
        display: flex;
        align-items: center;
        width: 100%;
    }
    
    .hub-tournament-matches__matches__match-team {
        width: 50%;
        justify-content: flex-start;
    }

    .hub-tournament-matches__matches__match-team:first-child {
        justify-content: flex-end;
    }

    .hub-tournament-matches__matches__match-team img {
        width: 24px;
        height: 24px;
        margin: 0 7px;
    }

    .hub-tournament-matches__matches__match-team .icon-ball {
        font-size: 20px;    
        padding: 2px;
        margin: 0 7px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-tournament-matches/HubTournamentMatchesComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,6DAA6D;IAC7D,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,gBAAgB;IAChB,UAAU;IACV,kDAAkD;AACtD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wDAAwD;IACxD,yDAAyD;IACzD,0BAA0B;AAC9B;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;;yBAEqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,yDAAyD;IAC7D;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".hub-tournament-matches__container {\n    padding-top: 70px;\n}\n\n.hub-tournament-matches__title {\n    position: absolute;\n    top: 72px;\n    left: calc(calc(calc(100% /12) * 3) - var(--space-and-half) );\n    padding: 24px 58px;\n    width: 100%;\n    background: var(--white-color);\n    text-align: left;\n    z-index: 1;\n    border-left: 1px solid var(--new-background-color);\n}\n\n.hub-tournament-matches__title.baloa-headline-3 {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches__empty{\n    width: 364px;\n    text-align: center;\n    margin: 50px auto;\n}\n\n.hub-tournament-matches__empty .baloa-subtitle-2 {\n    font-weight: var(--font-regular);\n    color: var(--primary-dark-color);\n    margin-top: 30px;\n}\n\n.hub-tournament-matches__accordion {\n    margin-bottom: 16px;\n    border-radius: 4px;\n}\n\n.hub-tournament-matches__tournament-matches  {\n    border-radius: 4px;\n}\n\n.hub-tournament-matches__tournament-matches.MuiPaper-elevation1 {\n    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.hub-tournament-matches__tournament-matches .MuiAccordionDetails-root {\n    padding: 10px;\n}\n\n.hub-tournament-matches__tournament-matches .MuiAccordionSummary-root {\n    min-height: 42px;\n}\n\n.hub-tournament-matches__tournament-matches .MuiAccordionSummary-root.Mui-expanded {\n    min-height: 42px;\n}\n\n.hub-tournament-matches__matches.MuiButtonBase-root{\n    background-color: var(--new-light-gray-background-color);    \n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-radius: 4px 4px 0 0;\n}\n\n.hub-tournament-matches__matches .MuiAccordionSummary-content,\n.hub-tournament-matches__matches .MuiAccordionSummary-content.Mui-expanded {\n    margin: 0;\n}\n\n.hub-tournament-matches__matches .MuiIconButton-root {\n    padding: 0 12px;\n}\n\n.hub-tournament-matches__matches__container{\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    width: 100%;\n}\n\n.hub-tournament-matches__matches__match{\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    cursor: pointer;\n}\n\n.hub-tournament-matches__matches__match-info{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.hub-tournament-matches__matches__match-date {\n    background-color: var(--new-background-color);\n    border-radius: 2px;\n    width: fit-content;\n    padding: 2px;\n}\n\n.hub-tournament-matches__matches__match-date.baloa-username {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches__matches__match-state {\n    padding: 2px;\n    border-radius: 2px;\n    width: fit-content;\n    background: var(--basic-gray-color);\n}\n\n.hub-tournament-matches__matches__match-state.baloa-username {\n    color: var(--white-color);\n}\n\n.hub-tournament-matches__matches__match-team {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n}\n\n.hub-tournament-matches__matches__match-team .icon-ball {\n    color: var(--white-color );\n    font-size: 24px;\n    border-radius: 50%;\n    padding: 3px;\n    margin-right: 8px;\n}\n\n.hub-tournament-matches__matches__match-team img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.hub-tournament-matches__matches__match-team.baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches__tournament_info {\n    display: flex;\n    align-items: center;\n    /* background: var(--new-background-color);\n    padding: 2px 4px;\n    border-radius: 2px; */\n}\n\n.hub-tournament-matches__tournament_info img {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.hub-tournament-matches__tournament_info .icon-ball {\n    color: var(--white-color );\n    font-size: 24px;\n    border-radius: 50%;\n    padding: 3px;\n    margin-right: 10px;\n}\n\n.hub-tournament-matches__tournament_info .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.hub-tournament-matches__matches__match-team-score {\n    margin-left: auto;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .hub-tournament-matches__container {\n        padding-top: 0;\n    }\n\n    .hub-tournament-matches__accordion {\n        margin-bottom: 12px;\n    }\n\n    .hub-tournament-matches__tournament-matches .MuiAccordionSummary-root.Mui-expanded {\n        min-height: 36px;\n    }\n\n    .hub-tournament-matches__tournament_info img {\n        width: 16px;\n        height: 16px;\n        margin-right: 4px;\n    }\n\n    .hub-tournament-matches__matches__container {\n        display: block;\n    }\n\n    .hub-tournament-matches__tournament-matches .MuiAccordionDetails-root {\n        padding: 0;\n    }\n\n    .hub-tournament-matches__matches__match {\n        padding: 8px;\n        border-radius: 0;\n        border: unset;\n        border-bottom: 1px solid var(--new-gray-background-color);\n    }\n\n    .hub-tournament-matches__matches__match-date {\n        margin: auto;\n    }\n\n    .hub-tournament-matches__matches__match-state {\n        margin: auto;\n    }\n\n    .hub-tournament-matches__matches__match-teams-info {\n        display: flex;\n        align-items: center;\n        width: 100%;\n    }\n    \n    .hub-tournament-matches__matches__match-team {\n        width: 50%;\n        justify-content: flex-start;\n    }\n\n    .hub-tournament-matches__matches__match-team:first-child {\n        justify-content: flex-end;\n    }\n\n    .hub-tournament-matches__matches__match-team img {\n        width: 24px;\n        height: 24px;\n        margin: 0 7px;\n    }\n\n    .hub-tournament-matches__matches__match-team .icon-ball {\n        font-size: 20px;    \n        padding: 2px;\n        margin: 0 7px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
